import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Alert } from '@snack-uikit/alert';
import { Link } from '@snack-uikit/link';
import { CATEGORY, PLATFORM } from '../../../constants';
import { EVOLUTION_PRODUCT } from './constants';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export var EVOLUTION_CATALOG = _defineProperty({}, PLATFORM.Evolution, [{
  id: CATEGORY.Popular,
  label: 'Популярное',
  dataTestId: 'popular',
  visibleProducts: [EVOLUTION_PRODUCT.EvolutionCloudServer, EVOLUTION_PRODUCT.EvolutionCloudServerFreeTier, EVOLUTION_PRODUCT.EvolutionKubernetes, EVOLUTION_PRODUCT.EvolutionStorageS3FreeTier, EVOLUTION_PRODUCT.EvolutionStorageS3]
}, {
  id: CATEGORY.FreeTier,
  label: 'Free Tier',
  dataTestId: 'free-tier',
  visibleProducts: [EVOLUTION_PRODUCT.EvolutionCloudServerFreeTier, EVOLUTION_PRODUCT.EvolutionStorageS3FreeTier, EVOLUTION_PRODUCT.EvolutionContainerAppsFreeTier],
  banner: /*#__PURE__*/_jsx(Alert, {
    appearance: "info",
    outline: true,
    description: /*#__PURE__*/_jsxs(_Fragment, {
      children: ["Free tier\xA0\u2014 \u044D\u0442\u043E \u043E\u0431\u043B\u0430\u0447\u043D\u044B\u0435 \u0440\u0435\u0441\u0443\u0440\u0441\u044B, \u0437\u0430\xA0\u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043D\u0435\xA0\u043D\u0430\u0434\u043E \u043F\u043B\u0430\u0442\u0438\u0442\u044C. \u041F\u043E\u0441\u043B\u0435 \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u0441\u0435\u0440\u0432\u0438\u0441 \u043E\u0441\u0442\u0430\u043D\u0435\u0442\u0441\u044F \u043D\u0430\u0432\u0441\u0435\u0433\u0434\u0430 \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u044B\u043C. \u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435 \u0432\xA0", /*#__PURE__*/_jsx(Link, {
        size: "m",
        appearance: "primary",
        textMode: "accent",
        insideText: true,
        target: "_blank",
        href: "https://cloud.ru/docs/evolution/overview/topics/free-tier.html",
        text: "\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u0438"
      })]
    })
  })
}, {
  id: CATEGORY.Computations,
  label: 'Инфраструктура',
  dataTestId: 'computations',
  visibleProducts: [EVOLUTION_PRODUCT.EvolutionCloudServer, EVOLUTION_PRODUCT.EvolutionCloudServerFreeTier, EVOLUTION_PRODUCT.EvolutionBareMetal, EVOLUTION_PRODUCT.EvolutionCloudServerGpu]
}, {
  id: CATEGORY.Network,
  label: 'Сети',
  dataTestId: 'network',
  visibleProducts: [EVOLUTION_PRODUCT.EvolutionSnatGateway, EVOLUTION_PRODUCT.EvolutionPublicIp]
}, {
  id: CATEGORY.Storage,
  label: 'Хранение и резервное копирование',
  dataTestId: 'storage',
  visibleProducts: [EVOLUTION_PRODUCT.EvolutionStorageS3, EVOLUTION_PRODUCT.EvolutionStorageS3FreeTier]
}, {
  id: CATEGORY.Containerization,
  label: 'Контейнеры',
  dataTestId: 'containerization',
  visibleProducts: [EVOLUTION_PRODUCT.EvolutionKubernetes, EVOLUTION_PRODUCT.EvolutionContainerApps, EVOLUTION_PRODUCT.EvolutionContainerAppsFreeTier, EVOLUTION_PRODUCT.EvolutionArtifactRegistry]
}, {
  id: CATEGORY.Database,
  label: 'Платформы данных',
  dataTestId: 'database',
  visibleProducts: [EVOLUTION_PRODUCT.EvolutionManagedPostgreSQL, EVOLUTION_PRODUCT.EvolutionArenadataDb]
}, {
  id: CATEGORY.ML,
  label: 'ML/AI Инструменты',
  dataTestId: 'ml',
  visibleProducts: [EVOLUTION_PRODUCT.EvolutionMlInference]
}]);